import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
// Base URL for API requests
const baseURL = API_ORIGIN;

// Retrieve token from localStorage
const token = localStorage.getItem("authToken");

console.log(token);
// Generic function to make API requests
function fetchData(url, method, data) {
  return axios({
    method: method,
    url: `${baseURL}/${url}`,
    headers: {
      "Content-Type": "application/json",
      token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
    },
    data: data,
  })
    .then((res) => res.data)
    .catch((error) => {
      console.error(
        `Error fetching data from ${url}:`,
        error.response?.data || error.message
      );
      throw error;
    });
}

// Custom hook that can be expanded later if needed
const useapi = () => {
  return { fetchData };
};

// Export specific API call functions
export function categorylist(data) {
  return fetchData(`admin-api/api/storecategory/list`, "post", data);
}

export function getsellerprofile(data) {
  return fetchData(`api/seller/get-seller-profile`, "post", data);
}

export function getcountry(data) {
  return fetchData(`api/user/countries`, "get", data);
}

export function getcorrencycode() {
  return fetchData(`api/seller/get-all-currency-code`, "get");
}

export function update_seller_profile(data) {
  return fetchData(`api/seller/get-all-currency-code`, data, "post");
}

// Default export for hook usage
export default useapi;
